module.exports = require('./lib/pipe.js')["default"];